<template>
  <div id="LqsAnalyser">
    <div class="">
      <div class="row datepickerwrap card" style="z-index: 998 !important;">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex" style="width: 70%">
            <div class="mr-2">
              <date-range-picker v-model="dateRange" opens='right' :autoApply="true"
                :locale-data="{ format: 'yyyy-mm-dd' }" :min-date="minDate" :max-date="maxDate" @update="dateChange">
              </date-range-picker>
            </div>
            <div class="customSelect mr-2">
              <select class="form-control text-uppercase " style="height:34px" v-model="selectedWebsite">
                <option value="" style="height:30px">Select Brand</option>
                <option style="height:30px" v-for="(d, i) in viewWebsitesDropdown" :key="i" :value="d.value">
                  {{ d.label }}</option>
              </select>
            </div>
            <div class="datebox customSelect">
              <select class="form-control text-uppercase " style="height:34px" v-model="selectedlink"
                @click="submitDetails">
                <option value="" style="height:30px">Select Name</option>
                <option style="height:30px" v-for="(d, i) in viewlinkesDropdown" :key="i" :value="d.link">{{ d.value }}
                </option>
              </select>
            </div>
            <div class="">
              <button class="btn primarycolor" type="button" style="height: 35px; padding: 3px 25px 6px 25px;"
                @click="submitDetails">
                <span style="font-size:13px">Submit</span>
              </button>
            </div>
          </div>
          <!-- <div class="lastUpdated ml-2" v-if="lastUpdated">
            Last Updated: {{ lastUpdated }}
          </div> -->
        </div>
      </div>
      <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
        <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
      </div>
      <div class="row datepickerwrap card">
        <div class="col-md-12 mycols">
          <div class="space-between capitalize">
            <a :href="selectedlink" target="_blanck" class="graphHeading">{{
              viewlinkesDropdown[viewlinkesDropdown.findIndex(obj => obj.link ==
                selectedlink)].value}}</a>
            <div class="mb-1" v-if="sellerGraph.data.length">
              <select class="form-control text-uppercase" style="height:34px" v-model="sellerGraph.selectedCategory"
                @click="processSellerGraphData">
                <option style="height:30px" v-for="d in sellerGraph.CategoryList" :key="d" :value="d">{{ d }}</option>
              </select>
            </div>
          </div>

          <div class="">
            <div style="margin:0" v-if="sellerGraph.data.length">
              <highcharts :options="lineChartData"></highcharts>
            </div>
            <div class="noData mt-3" v-else>No Data!</div>
          </div>
        </div>
      </div>
      <!-- <div v-if="!rank">
        <keyword-tracker-table-data />
      </div> -->
      <div v-if="bestSellerSections.seller_rank_table">
        <div class="row datepickerwrap card" style="z-index: 998 !important;" v-if="viewBestSellersRankFiltereData">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center" style="width: 80%">
              <div class="customSelect mr-2">
                <div class="mb-1 mt-2">Date</div>
                <date-range-picker style="width: 150px;" v-model="dateRangeBestSeller" :show-dropdowns="true"
                  opens='right' :autoApply="true" :locale-data="{ format: 'dd mmm yyyy' }" :min-date="bestSellerMinDate"
                  :max-date="bestSellerMaxDate" :single-date-picker="true" :ranges="false">
                </date-range-picker>
              </div>
              <div class="customSelect mr-2">
                <div class="mb-1">Platform</div>
                <select class="form-control text-uppercase " style="height:34px" v-model="selectedPlatform"
                  @change="filterCategoryData(true)">
                  <!-- <option value="" style="height:30px">Amazon</option> -->
                  <option style="height:30px" v-for="(d, i) in viewPlatformList" :key="i" :value="d">
                    {{ d }}</option>
                </select>
              </div>
              <div class="datebox customSelect">
                <div class="mb-1">Category</div>
                <select class="form-control text-uppercase " style="height:34px" v-model="selectedCategory"
                  @change="filterSubCategoryData(true)">
                  <!-- <option value="" style="height:30px">Large Appliances </option> -->
                  <option style="height:30px" v-for="(d, i) in viewCategoryList" :key="i" :value="d">{{ d }}
                  </option>
                </select>
              </div>
              <div class="datebox customSelect">
                <div class="mb-1">Sub Category</div>
                <select class="form-control text-uppercase " style="height:34px" v-model="selectedSubCategory"
                  @change="filterPriceBandData(true)">
                  <!-- <option value="" style="height:30px">Refrigerator</option> -->
                  <option style="height:30px" v-for="(d, i) in viewSubCategoryList" :key="i" :value="d">{{ d }}
                  </option>
                </select>
              </div>
              <div class="datebox customSelect">
                <div class="mb-1">Price Range</div>
                <select class="form-control text-uppercase " style="height:34px" v-model="selectedPriceBand">
                  <option value="" style="height:30px">All</option>
                  <option style="height:30px" v-for="(d, i) in viewPriceBandList" :key="i" :value="d">{{ d }}
                  </option>
                </select>
              </div>
              <button class="btn primarycolor mt-4" type="button" style="height: 35px; padding: 3px 25px 6px 25px;"
                @click="getBestSellerRankData(true)">
                <span style="font-size:13px">Apply Filter</span>
              </button>
            </div>
            <div class="lastUpdated ml-2 mt-4">
              Last Updated: {{ bestSellerLastUpdatedDataDate }}
            </div>
          </div>
        </div>
        <div class="row datepickerwrap card" v-if="viewBestSellersRankTableBodyData.length">
          <table id="bestSellerRankTable">
            <thead>
              <tr>
                <th v-for="head of viewBestSellersRankTableHeaderData" :key="head.key">{{ head.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="td of viewBestSellersRankTableBodyData" :key="td + rank">
                <td v-for="head of viewBestSellersRankTableHeaderData" :key="head.key">
                  <div v-if="head.key == 'product_name'">
                    <a :href="td.product_link" target="_blank">{{ td[head.key] }}</a>
                  </div>
                  <div v-else>{{ td[head.key] }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row datepickerwrap card noData mt-3 border-red" v-else>No Data!</div>
      </div>
    </div>
  </div>

</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import KeywordTrackerTableData from './KeywordTrackerTableData.vue'
export default {
  name: 'KeywordTracker',
  components: { Datepicker, KeywordTrackerTableData },

  data: function () {
    return {
      lineChartData: {},
      loader: false,
      dateRange: {
        startDate: moment().subtract(1, 'week').format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, 'month')),
      selectedWebsite: '',
      selectedlink: '',
      viewWebsitesDropdown: [],
      viewlinkesDropdown: [],
      lastUpdated: '',
      sellerGraph: {
        data: [],
        CategoryList: '',
        selectedCategory: ''
      },
      rank: JSON.parse(localStorage.reviewUserData).data.is_rank,
      client: JSON.parse(localStorage.reviewUserData).data.client,
      // best seller rank table variable
      viewBestSellersRankTableBodyData: '',
      viewBestSellersRankTableHeaderData: '',
      viewBestSellersRankFiltereData: '',
      viewPlatformList: '',
      viewCategoryList: '',
      viewSubCategoryList: '',
      viewPriceBandList: '',
      selectedPlatform: '',
      selectedCategory: '',
      selectedSubCategory: '',
      selectedPriceBand: '',
      dateRangeBestSeller: {
        startDate: moment('08-31-2024').format("YYYY-MM-DD"),
        endDate: moment('08-31-2024').format("YYYY-MM-DD"),
      },
      bestSellerMinDate: '',
      bestSellerMaxDate: '',
      bestSellerLastUpdatedDataDate: '',
      bestSellerSections: {
        seller_rank_table: true
      }
    }

  },
  created() {
    if (JSON.parse(localStorage.reviewUserData).data.best_seller_sections) {
      this.bestSellerSections = JSON.parse(localStorage.reviewUserData).data.best_seller_sections
    }
  },
  mounted() {
    this.getLastUpdatedDates()
    // this.dataAPIs()
  },

  methods: {
    getLastUpdatedDates() {
      this.loader0 = true;

      const url = `/api/v2/india_clients/last_update?client=${this.client}`;
      this.$http.get(url).then(
        (response) => {
          if (response.body.data.best_sellers_ranking) {
            localStorage.best_sellers_ranking_last_update = JSON.stringify(response.body.data.best_sellers_ranking);
            this.dateRange.endDate = moment(response.body.data.best_sellers_ranking.end_date).format("YYYY-MM-DD");
            this.dateRange.startDate = moment(response.body.data.best_sellers_ranking.end_date).subtract(1, 'week').format("YYYY-MM-DD");
            this.maxDate = new Date(response.body.data.best_sellers_ranking.end_date);
            this.minDate = new Date(response.body.data.best_sellers_ranking.start_date)
            this.lastUpdated = `${moment(
              response.body.data.best_sellers_ranking.end_date
            ).format("DD MMM, YYYY")} ${
              response.body.data.best_sellers_ranking.latest_time ? "at" : ""
            } ${response.body.data.best_sellers_ranking.latest_time}`;
            this.$store.dispatch("DemoStore/setTimeStamp", this.lastUpdated);

          }
          this.loader0 = false;
          this.dataAPIs()
        },
        (err) => {
          this.loader0 = false;
          this.dataAPIs()
          console.log("err");
        }
      );
    },
    dataAPIs() {
      this.formatDates()
      this.getWebsiteandKeywordDropdownData();
      if (this.bestSellerSections.seller_rank_table)
        this.getBestSellerRankData(false);
    },
    formatDates() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format('YYYY-MM-DD')
      this.dateRange.endDate = moment(this.dateRange.endDate).format('YYYY-MM-DD')

    },
    dateChange() {
      this.formatDates();
    },

    getWebsiteandKeywordDropdownData() {
      let self = this
      self.loader = true
      let payload = {
        // client: this.client
      }
      const url = "/api/v2/websites/amazon_seller_brand_link_and_name"
      self.$http.post(url, payload).then(response => {
        if (Object.keys(response.data.data.data).length)
          this.selectedWebsite = response.data.data.data.data[0].value
        this.selectedlink = response.data.data.data.link[0].link
        self.viewWebsitesDropdown = response.data.data.data.data
        self.viewlinkesDropdown = response.data.data.data.link
        self.loader = false
        this.submitDetails()
      }).catch(err => {
        self.loader = false
        console.log('err')
      });
    },

    getBestSellerRankData(applyFilter) {
      let self = this
      self.viewBestSellersRankTableBodyData = ''
      self.viewBestSellersRankTableHeaderData = ''
      self.loader = true
      let payload = {}
      let url = "/api/v2/bestsellersranks";
      if (applyFilter) {
        payload.extract_date = moment(self.dateRangeBestSeller.startDate).format("YYYY-MM-DD"),
          payload.category = this.selectedSubCategory,
          payload.price_range = this.selectedPriceBand
        payload.plateform = this.selectedPlatform
        $("#bestSellerRankTable").DataTable().destroy();
      }

      self.$http.post(url, payload).then(response => {
        self.viewBestSellersRankTableHeaderData = response.data.data.header
        self.viewBestSellersRankTableBodyData = response.data.data.sellerRankData
        if (!applyFilter) {
          self.bestSellerLastUpdatedDataDate = moment(response.data.data.updated_dates.last_updated).format("DD MMM, YYYY")
          self.dateRangeBestSeller.startDate = moment(response.data.data.updated_dates.last_updated).format("YYYY-MM-DD")
          self.dateRangeBestSeller.endDate = moment(response.data.data.updated_dates.last_updated).format("YYYY-MM-DD")
          self.bestSellerMinDate = new Date(response.data.data.updated_dates.start_date);
          self.bestSellerMaxDate = new Date(response.data.data.updated_dates.end_date);
          self.viewBestSellersRankFiltereData = response.data.data.filters
          self.selectedPlatform = response.data.data.selected_category.plateform
          self.selectedCategory = response.data.data.selected_category.sub_category1
          self.selectedSubCategory = response.data.data.selected_category.sub_category2
          self.selectedPriceBand = response.data.data.selected_category.price
          this.processBestSellerFilter(false);
        }
        self.$nextTick(() => {
          $("#bestSellerRankTable").dataTable();
          $("#bestSellerRankTable").DataTable().destroy();
          $("#bestSellerRankTable").DataTable({
            autoWidth: false,
            language: {
              search: "",
              paginate: {
                first: "",
                previous: "<",
                next: ">",
                last: "",
              },
              lengthMenu: "<h5>Show entries</h5> _MENU_",
            },
            pagingType: "full_numbers",
          });
          let search = require("../../../public/Icons_SVG/Search.svg");
          $("#bestSellerRankTable_filter > label > input").attr("placeholder", "Search");
          $("#bestSellerRankTable_filter > label").append(`<div><img src='${search}' /></div>`);
          $("#bestSellerRankTable_length > label > select").removeClass();
        });
        self.loader = false;

      }).catch(err => {
        self.loader = false
        console.log('err')
      });
    },

    submitDetails() {
      let self = this
      self.loader = true
      self.sellerGraph.data = []
      let payload = {
        "start_date": self.dateRange.startDate,
        "end_date": self.dateRange.endDate,
        "link": self.selectedlink
      }
      const url = "/api/v2/adword/amazon_seller_link_graph"
      self.$http.post(url, payload).then(response => {
        if (Object.keys(response.data.data).length)
          self.sellerGraph.data = response.data.data.data
        self.processCategoryListData()
        self.loader = false
      }).catch(err => {
        self.loader = false
        console.log('err')
      });
    },

    processBestSellerFilter(applyFilter) {
      this.viewPlatformList = []
      Object.entries(this.viewBestSellersRankFiltereData).forEach(([key, value]) => {
        this.viewPlatformList.push(key)
      })
      if (applyFilter)
        this.selectedPlatform = this.viewPlatformList[0]
      this.filterCategoryData(applyFilter)
    },

    filterCategoryData(applyFilter) {
      this.viewCategoryList = []
      Object.entries(this.viewBestSellersRankFiltereData[this.selectedPlatform]).forEach(([key, value]) => {
        this.viewCategoryList.push(key)
      })
      if (applyFilter)
        this.selectedCategory = this.viewCategoryList[0]
      this.filterSubCategoryData(applyFilter)
    },

    filterSubCategoryData(applyFilter) {
      this.viewSubCategoryList = []
      Object.entries(this.viewBestSellersRankFiltereData[this.selectedPlatform][this.selectedCategory]).forEach(([key, value]) => {
        this.viewSubCategoryList.push(key)
      })
      if (applyFilter)
        this.selectedSubCategory = this.viewSubCategoryList[0]
      this.filterPriceBandData(applyFilter);
    },

    filterPriceBandData(applyFilter) {
      this.viewPriceBandList = []
      Object.entries(this.viewBestSellersRankFiltereData[this.selectedPlatform][this.selectedCategory][this.selectedSubCategory]).forEach(([key, value]) => {
        this.viewPriceBandList.push(value)
      })
      if (applyFilter)
        this.selectedPriceBand = this.viewPriceBandList[0]
    },

    processCategoryListData() {
      let self = this;
      let amazonSellerData = self.sellerGraph.data;
      let temp = [];
      for (let d of amazonSellerData) {
        if (!temp.includes(d))
          temp.push(d.category)
      }
      self.sellerGraph.CategoryList = temp;
      self.sellerGraph.selectedCategory = self.sellerGraph.CategoryList[0]
      self.processSellerGraphData();
    },

    processSellerGraphData() {
      let self = this;
      self.loader = true;
      let amazonSellerData = self.sellerGraph.data;
      let seriesData = [{
        name: '',
        data: [],
        color: '#47A694',
      }];

      let xaxis = [];
      for (let d of amazonSellerData) {
        if (d.category == self.sellerGraph.selectedCategory) {
          seriesData[0].name = self.sellerGraph.selectedCategory
          for (const d2 of d.data) {
            xaxis.push(moment(d2.timestamp).format('DD MMM YYYY'))
            seriesData[0].data.push(d2.rank)
          }
          self.lineChart(xaxis, seriesData)
          self.loader = false;
        }
      }
    },


    lineChart(xaxis, seriesData) {
      this.lineChartData = {
        chart: {
          type: 'line',
          height: 250,
        },
        lang: {
          thousandsSep: ""
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        title: {
          text: '',
        },

        xAxis: {
          categories: xaxis,
          tickmarkPlacement: 'on',
          crosshair: true,
          crosshair: {
            width: 70,

          },
        },

        yAxis: {
          min: 0,
          title: {
            enabled: false
          },
          labels: {
          },
        },
        legend: {
          enabled: true,
        },
        tooltip: {
          formatter: function () {
            return this.x + ' : <b>' + (this.y).toLocaleString("en-US") + '</b>';
          },
          shared: true,
          borderWidth: 0,
          shadow: {
            color: "#d6d6d6",
            opacity: 0.1,
            width: 10,
          },
          borderRadius: 6,
          backgroundColor: "#ffffff",
        },
        plotOptions: {
          series: {
            marker: {
              enabled: true,
              symbol: 'circle'
            }
          }
        },
        series: seriesData
      }
    },
  }
}

</script>

<style scoped>
.capitalize {
  text-transform: capitalize;

}

.lastUpdated {
  color: #065559;
  font-size: 12px;
  padding: 6px 12px;
  border: 1px solid var(--base_color-80);
  border-radius: 6px;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.mainHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1.3125rem;
}

.secondaryHeading {
  color: #4e4e4e;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.textColor {
  color: #818890 !important;
}

.flex-start {
  display: flex;
  justify-content: flex-start;
}

.inputBox {
  height: 30px;
  border: 1px solid silver;
  display: flex;
  justify-content: start;
  background: white;
}

.inputBox input {
  border-radius: 0px;
  border: none !important;
}

.sideBorder {
  border-right: 1px solid #c1c1c1;
}

input:focus {
  outline: none !important;
  box-shadow: none !important;
}

.trueIcon {
  color: #64ac94 !important;
}

.falseIcon {
  color: #ff0000 !important;
}

.cardButton {
  margin-left: 10px;
}

.productCart {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid silver;
  padding: 10px;
}

.productImg {
  width: 6vw;
}

.product-title {
  font-size: 22px;
  ;
}

.productImg img {
  width: 100%;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  letter-spacing: 0.2px;
  font-weight: bold;
  font-size: 16px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}

select {
  font-family: "Poppins", sans-serif;
}

select {
  border-radius: 5px !important;
}

select option {
  text-transform: capitalize;
  padding: 10px 0px;
}

.noData {
  border: 1px solid #fbb1b1;
  border-radius: 5px;
  padding: 10px;
  background: #fff7f7;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
}
</style>
<style>
#bestSellerRankTable_filter>label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}

#bestSellerRankTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}

#bestSellerRankTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}

#bestSellerRankTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}

#bestSellerRankTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#bestSellerRankTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}

#bestSellerRankTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}

#bestSellerRankTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}

#bestSellerRankTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%) contrast(104%);
}

#bestSellerRankTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}

#bestSellerRankTable_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}

#bestSellerRankTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}

#bestSellerRankTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}

#bestSellerRankTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}

#bestSellerRankTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}

#bestSellerRankTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}

#bestSellerRankTable {
  border-radius: 20px 20px 0 0 !important;
}

#bestSellerRankTable .thead-normal,
#bestSellerRankTable .thead-normal tr:first-child,
#bestSellerRankTable .thead-normal>tr:first-child>th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0 !important;
  border-left: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal>tr:last-child>th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal>tr:first-child>th:last-child {
  border-radius: 0 21px 0 0;
}

#bestSellerRankTable .thead-normal>tr:first-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px 0px 25px !important;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal>tr:last-child>th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
  border-right: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .thead-normal>tr>th.sorting:before {
  font-size: 12px;
  bottom: 60%;
  color: var(--base_color-80);
}

#bestSellerRankTable .thead-normal>tr>th.sorting:after {
  font-size: 12px;
  top: 50%;
  color: var(--base_color-80);
}

#bestSellerRankTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}

#bestSellerRankTable tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#bestSellerRankTable tfoot th:first-child {
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}

#bestSellerRankTable tbody td {
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}

#bestSellerRankTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}

#bestSellerRankTable .even td {
  background: #fff !important;
}

#bestSellerRankTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #bestSellerRankTable_wrapper .bottom {
  margin: -30px;
} */
#bestSellerRankTable_wrapper>.row:last-child {
  margin-bottom: 15px;
}

#bestSellerRankTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}

#bestSellerRankTable_wrapper .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}
</style>